const DomUtil = {};

DomUtil.asyncScriptLoad = function(url, onSuccess, onError) {
	if (!url || typeof url !== 'string') {
		return;
	}

	const script = document.createElement('script');
	script.async = true;
	script.src = url;

	if (typeof onSuccess === 'function') {
		script.addEventListener('load', onSuccess, false);
	}
	if (typeof onError === 'function') {
		script.addEventListener('error', onError, false);
	}

	const [firstScriptTag] = document.getElementsByTagName('script');
	firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
};

export default DomUtil;